const flights = {
  list: {
    priceWidth: {
      desktop: '250px',
      midSized: '190px',
      mobile: '110px',
    },
  },
};

export default flights;
